import {useState} from 'react';
import Turnstile from "react-turnstile";
import { useTranslation } from 'react-i18next';
import SlideUp from "../ui/SlideUp";
import emailjs from '@emailjs/browser';
import settings from "../../constants/settings";
import {AddressPin, EmailEnvelopIcon, phoneCalling} from "../../constants/svgIcons";

const Contact = () => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    subject: '',
    message: ''
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMsg, setSuccessMsg] = useState('');
  const [messageColor, setMessageColor] = useState('');
  const [token, setToken] = useState("");
  const [turnstileKey, setTurnstileKey] = useState(0);

  // REPLACE resetTurnstile with this simpler version
  const resetTurnstile = () => {
    setTurnstileKey(prev => prev + 1); // This will remount the component
    setToken('');
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = t('common.fieldRequired');
    if (!formData.phone.trim()) newErrors.phone = t('common.fieldRequired');
    if (!formData.email.trim()) newErrors.email = t('common.fieldRequired');
    else if (!/\S+@\S+\.\S+/.test(formData.email)) newErrors.email = 'This field is invalid';
    if (!formData.subject.trim()) newErrors.subject = t('common.fieldRequired');
    if (!formData.message.trim()) newErrors.message = t('common.fieldRequired');
    if (!token) newErrors.verification = 'Please complete the verification';
    return newErrors;
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.id.toLowerCase()]: e.target.value });
  };

  // Helper functions
  const showStatusMessage = (message, type) => {
    setErrors({}); // Clear previous errors
    setMessageColor(type === 'success' ? 'text-green-600' : 'text-red-600');
    setSuccessMsg(message);

    // Clear message after 5 seconds
    const timer = setTimeout(() => {
      setSuccessMsg('');
      setMessageColor('');
      clearTimeout(timer);
    }, 5000);
  };

  const robotCheck = async () => {
    try {
      const verifyResponse = await fetch('https://robot-check.yellaung.workers.dev', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          token: token, // Only send token
        })
      });

      if (!verifyResponse.ok) {
        console.error('Verification request failed:', verifyResponse.status);
        return { success: false };
      }

      const verifyData = await verifyResponse.json();
      return verifyData;
    } catch (error) {
      console.error('Robot check error:', error);
      return { success: false };
    }
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      setIsSubmitting(false)
      // resetTurnstile()
      return;
    }

    const robotCheckResult = await robotCheck();

    if (!robotCheckResult.success) { // FIX: Check .success property
      setErrors({message: "Verification failed. Please try again."});
      setIsSubmitting(false)
      resetTurnstile()
      return;
    }

    try {
      await emailjs.send(
        settings.emailService.serviceId,
        settings.emailService.templateId,
        formData,
        { publicKey: settings.emailService.publicKey }
      );
      showStatusMessage('Your message has been sent! We will get back to you soon.', 'success');
      setFormData({ name: '', phone: '', email: '', subject: '', message: '' });
      resetTurnstile()
    } catch (err) {
      showStatusMessage('Something went wrong. Please try again later.', 'error');
      resetTurnstile()
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <div>
      <div className="py-14 add-circle-bg">
        <div className="md:w-theme-container w-mobile-container mx-auto mb-20">
          <SlideUp duration={1}>
            <div className="text-center text-2xl my-12">{t('common.connectWithUs')}</div>
          </SlideUp>
          <div className="grid grid-cols-1 md:grid-cols-[45%_1fr] gap-7 mt-10">
            <div className="flex flex-col justify-between gap-7">
              <div className="flex md:h-64 flex-col justify-between items-center ">
                <div className="w-full flex justify-between items-center mb-5 h-28 bg-white border-r-4 border-theme-color rounded-xl shadow-2xl">
                  <div className="w-[20%] h-28 flex items-center justify-center">
                    <AddressPin color={'#0080FF'} pixel={40} />
                  </div>
                  <div className="w-[80%] h-28 flex flex-col justify-center items-start">
                    {/*<div className="md:text-base text-sm">{t('common.addressDescription')}</div>*/}
                    <div className="md:text-base text-sm">MESOFT Business Solutions L.L.C</div>
                    <div className="md:text-base text-sm">P.O. Box: 5012, Airport-Road Near Terminal 1</div>
                    <div className="md:text-base text-sm">Dubai, United Arab Emirates.</div>
                  </div>
                </div>
                <div className="w-full gap-6 grid md:grid-cols-2 grid-cols-1">
                  <div className="w-full flex justify-between items-center h-28 bg-white border-r-4 border-theme-color rounded-xl shadow-2xl">
                    <div className="w-[20%] h-28 flex items-center justify-center">
                      <EmailEnvelopIcon color={'#0080FF'} pixel={43} />
                    </div>
                    <div className="w-[80%] h-28 flex flex-col justify-center gap-2">
                      <a href='mailto:info@mesoft.ae' className="md:text-base text-sm">info@mesoft.ae</a>
                      {/*<div className="md:text-base text-sm">contact@mesoft.ae</div>*/}
                    </div>
                  </div>
                  <div className="w-full flex justify-between items-center h-28 bg-white border-r-4 border-theme-color rounded-xl shadow-2xl">
                    <div className="w-[20%] h-28 flex items-center justify-center">
                      {phoneCalling('#0080FF',35)}
                    </div>
                    <div className="w-[80%] h-28 flex flex-col justify-center gap-2">
                      <div className="md:text-base text-sm">+971 4 2829 613 </div>
                      <div className="md:text-base text-sm">+971 50 570 7868</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="w-full h-[425px] rounded-xl overflow-hidden">
                <SlideUp
                  duration={1.4}
                >
                  <iframe
                    className="w-full h-svh rounded-xl border-0"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4477.701055213561!2d55.33769317608363!3d25.254681929368758!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f5d1e3cff5b97%3A0xca720218c4ca13d!2sMesoft%20Business%20Solutions%20L.L.C.!5e1!3m2!1sen!2sae!4v1748521946232!5m2!1sen!2sae"
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Google Maps Location"
                  ></iframe>
                </SlideUp>
              </div>
            </div>
            <div className="w-full">
              <SlideUp
                duration={1.3}
              >
                <div className="card px-5 pt-8 pb-4 w-full bg-white border border-slate-200 rounded-xl shadow-2xl">
                  <form
                    onSubmit={handleSubmit}
                  >

                    <div className="text-center my-5 text-2xl md:text-3xl text-black">{t('common.weLoveToHear')}</div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mt-8 mb-5">
                      <div className="form-group">
                        <label className="text-lg md:text-lg text-start text-black inline" htmlFor="Name" >{t('common.name')}</label>
                        {errors.name && <p className="text-red-500 ml-3 text-sm inline">{errors.name}</p>}
                        <input
                          type="text"
                          id="Name"
                          name="name"
                          className="w-full border border-slate-300 p-[10px] outline-none bg-slate-100  rounded text-black"
                          value={formData.name}
                          onChange={handleChange}
                        />

                      </div>
                      <div className="form-group">
                        <label className="text-lg md:text-lg text-start text-black inline" htmlFor="Phone" >{t('common.phone')}</label>
                        {errors.phone && <p className="text-red-500 ml-3 text-sm inline">{errors.phone}</p>}
                        <input
                          type="text"
                          className="w-full border border-slate-300 p-[10px] outline-none bg-slate-100  rounded text-black"
                          id="Phone"
                          name="phone"
                          value={formData.phone}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="grid grid-cols-1 gap-5 mb-5">
                      <div className="form-group">
                        <label className="text-lg md:text-lg text-start text-black inline" htmlFor="Email" >{t('common.email')}</label>
                        {errors.email && <p className="text-red-500 ml-3 text-sm inline">{errors.email}</p>}
                        <input
                          type="email"
                          className="w-full border border-slate-300 p-[10px] outline-none bg-slate-100  rounded text-black"
                          id="Email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="grid grid-cols-1 gap-5 mb-5">
                      <div className="form-group">
                        <label className="text-lg md:text-lg text-start text-black inline" htmlFor="Subject" >{t('common.subject')}</label>
                        {errors.subject && <p className="text-red-500 ml-3 text-sm inline">{errors.subject}</p>}
                        <input
                          type="text"
                          className="w-full border border-slate-300 p-[10px] outline-none bg-slate-100  rounded text-black"
                          id="Subject"
                          name="subject"
                          value={formData.subject}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="grid grid-cols-1 gap-5 mb-5">
                      <div className="form-group">
                        <label className="text-lg md:text-lg text-start text-black inline" htmlFor="Message" >{t('common.message')}</label>
                        {errors.message && <p className="text-red-500 ml-3 text-sm inline">{errors.message}</p>}
                        <textarea
                          maxLength={255}
                          className="w-full border border-slate-300 p-[10px] outline-none bg-slate-100  rounded text-black"
                          id="Message"
                          name="message"
                          value={formData.message}
                          onChange={handleChange}
                          rows={3}
                        ></textarea>
                      </div>
                    </div>
                    {errors.verification && <p className="text-red-500 ml-3 text-sm inline">{errors.verification}</p>}
                    <Turnstile
                      key={turnstileKey}
                      sitekey={process.env.REACT_APP_CLOUDFLARE_TURNSTILE_SITE_KEY}
                      onVerify={(t) => {
                        setToken(t);
                      }}
                      onError={() => setToken('')}
                      onExpire={() => setToken('')}
                    />
                    <button
                      type={"submit"}
                      disabled={isSubmitting}
                      className="w-28 rounded-3xl mt-8 h-10 bg-theme-color text-white text-center flex justify-center items-center"
                    >{isSubmitting ? 'Sending...' : t('common.submit')}</button>
                    <div className={`flex items-center justify-center h-6 mt-3 bg-yellow-3000 text-center ${messageColor}`}>
                      {successMsg && <p>{successMsg}</p>}
                    </div>
                  </form>
                </div>
              </SlideUp>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;